import { Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { BrowsedJobDetailsContainerStyled } from '../TechnicianBrowsedJobDetails/style';

type Props = {
  userName: string;
  userType: string;
  userEmail: string;
  contactNumber: string;
  userAddress: string;
};

const UserInformation = ({
  userName,
  userType,
  userEmail,
  contactNumber,
  userAddress,
}: Props) => {
  return (
    <BrowsedJobDetailsContainerStyled>
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        USER INFORMATION
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled className="userName">
          <Typography className="title" fontColor="dark">
            User Name :{' '}
          </Typography>
          <Typography className="value">{userName}</Typography>
        </InfoRowStyled>
        <InfoRowStyled className="userEmail">
          <Typography className="title" fontColor="dark">
            User Email :
          </Typography>
          <Typography className="value">{userEmail}</Typography>
        </InfoRowStyled>
        <InfoRowStyled className="userContact">
          <Typography className="title" fontColor="dark">
            Contact Number:{' '}
          </Typography>
          <Typography>{`${contactNumber}`}</Typography>
        </InfoRowStyled>
        <InfoRowStyled className="userAddress">
          <Typography className="title" fontColor="dark">
            User Address :
          </Typography>
          <Typography>{userAddress}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </BrowsedJobDetailsContainerStyled>
  );
};

export default UserInformation;
